import { FC } from "react";
import { Navigate, useParams } from "react-router";

import { APP_BASE_HREF } from "../../App";
import { useLatestRevision } from "../../queries/schematisations";

const SchematisationsRedirectToLatest: FC = () => {
  const { id } = useParams<{ id: string }>();

  const idNumber = parseInt(id + "", 10);

  const numberIsInvalid = isNaN(idNumber);

  const schematisationsResponse = useLatestRevision(numberIsInvalid ? undefined : idNumber);

  if (numberIsInvalid) {
    return <Navigate replace to={`${APP_BASE_HREF}/schematisations/`} />;
  }

  const lastRevision = schematisationsResponse.isSuccess ? schematisationsResponse.data : null;

  if (lastRevision && lastRevision.id)
    return <Navigate replace to={`${APP_BASE_HREF}/schematisations/${id}/${lastRevision.id}`} />;

  if (schematisationsResponse.isError) {
    // This schematisation has no revision
    return <Navigate replace to={`${APP_BASE_HREF}/schematisations/${id}/new`} />;
  }

  return null;
};

export default SchematisationsRedirectToLatest;
